import { URL_API } from "../../../general/init/url";

export const API_USERS_WATING_LIST = (projectCode, session) =>
  URL_API +
  "/api/project/assessmentMethodSession/" +
  projectCode +
  "/" +
  session +
  "/userInSession";

export const API_SET_JOIN_ROOM = (projectCode, session) =>
  URL_API +
  "/api/project/assessmentMethodSession/" +
  projectCode +
  "/" +
  session +
  "/openRoom";
